// packages/api-client/src/services/admin/adminInvestmentsService.ts
import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { ServiceResponse, PaginatedResponse, InvestmentRecord, UUID } from '@dopomogai/types';

// Define the shape of the query parameters for the list endpoint
export interface InvestmentListFilters {
  limit?: number;
  offset?: number;
  user_id?: UUID;
  agent_id?: string;
}

const ADMIN_INVESTMENTS_PREFIX = '/admin/investments';

export const adminInvestmentsService = {
  /**
   * Fetches a paginated list of all investment records, with optional filters.
   */
  listAllInvestments: (filters: InvestmentListFilters): ServiceResponse<PaginatedResponse<InvestmentRecord>> => {
    return getApiClient().get<PaginatedResponse<InvestmentRecord>>(`${ADMIN_INVESTMENTS_PREFIX}/`, { params: filters })
      .then(res => res.data)
      .catch(err => handleApiError(err, 'listing all investments'));
  },

  /**
   * Fetches a single investment record by its ID.
   */
  getInvestmentById: (investmentId: UUID): ServiceResponse<InvestmentRecord> => {
    return getApiClient().get<InvestmentRecord>(`${ADMIN_INVESTMENTS_PREFIX}/${investmentId}`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `fetching investment '${investmentId}'`));
  },
};